"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendRequest = void 0;

var _constants = require("../../config/constants");

var _generateId = require("../generateId");

var _function = require("../type-checks/function");

var _string = require("../type-checks/string");

var _codec = require("../codec");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var activeRequests = [];

var sendRequest = function sendRequest(endpoint, configs) {
  var alwaysCallback = configs.alwaysCallback,
      beforeCallback = configs.beforeCallback,
      _configs$cancelDuplic = configs.cancelDuplicates,
      cancelDuplicates = _configs$cancelDuplic === void 0 ? true : _configs$cancelDuplic,
      _configs$credentials = configs.credentials,
      credentials = _configs$credentials === void 0 ? "include" : _configs$credentials,
      _configs$data = configs.data,
      data = _configs$data === void 0 ? {} : _configs$data,
      errorCallback = configs.errorCallback,
      failCallback = configs.failCallback,
      _configs$headers = configs.headers,
      headers = _configs$headers === void 0 ? {} : _configs$headers,
      _configs$method = configs.method,
      method = _configs$method === void 0 ? _constants.REQUEST_METHOD.GET : _configs$method,
      successCallback = configs.successCallback,
      throwCallback = configs.throwCallback;

  try {
    var requestConfig = {
      credentials: credentials,
      headers: _objectSpread({
        "Content-Type": "application/json"
      }, headers),
      method: method.toUpperCase()
    };

    if (["DELETE", "PATCH", "POST", "PUT"].includes(method.toUpperCase())) {
      requestConfig.body = JSON.stringify(data);
    }

    if (!(0, _string.isStringOfLength)(endpoint)) {
      throw new Error("Invalid URI provided to Fetch API: ".concat(endpoint));
    }

    var requestId = "".concat(method.toUpperCase(), ":").concat(endpoint);
    var requestHash = (0, _codec.toBase64)(requestId);

    if (cancelDuplicates && activeRequests.includes(requestHash)) {
      console.warn("Existing request ".concat(requestId, " identified, subsequent request canceled."));
    } else if (!cancelDuplicates) {
      requestHash = (0, _codec.toBase64)("".concat(requestId, ":").concat((0, _generateId.generateId)()));
    }

    activeRequests.push(requestHash);
    (0, _function.isFunction)(beforeCallback) && beforeCallback();
    return fetch(endpoint, requestConfig).then( /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
        var body, responseObj, _body, _responseObj;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!response.ok) {
                  _context.next = 14;
                  break;
                }

                if (!(response.status === 204)) {
                  _context.next = 5;
                  break;
                }

                _context.t0 = {};
                _context.next = 8;
                break;

              case 5:
                _context.next = 7;
                return response.json();

              case 7:
                _context.t0 = _context.sent;

              case 8:
                body = _context.t0;
                responseObj = {
                  body: body,
                  headers: response.headers,
                  status: response.status
                };
                (0, _function.isFunction)(successCallback) && successCallback(responseObj);
                return _context.abrupt("return", responseObj);

              case 14:
                _context.next = 16;
                return response.text();

              case 16:
                _body = _context.sent;
                _responseObj = {
                  body: _body,
                  headers: response.headers,
                  status: response.status
                };
                (0, _function.isFunction)(errorCallback) && errorCallback(_responseObj);
                return _context.abrupt("return", _responseObj);

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }()).catch(function (error) {
      (0, _function.isFunction)(failCallback) && failCallback(error);
    }).finally(function () {
      activeRequests = activeRequests.filter(function (req) {
        return req !== requestHash;
      });
      (0, _function.isFunction)(alwaysCallback) && alwaysCallback();
    });
  } catch (e) {
    console.error(e);
    (0, _function.isFunction)(throwCallback) && throwCallback();
  }
};

exports.sendRequest = sendRequest;